<template>
  <v-carousel
    cycle
    height="400"
    hide-delimiter-background
    hide-delimiters
    show-arrows-on-hover
  >
    <v-carousel-item>
      <v-sheet
        color="black"
        height="100%"
        class="slide1 no-radius"
      >
        <Slide1 />
      </v-sheet>
    </v-carousel-item>
    <v-carousel-item>
      <v-sheet
        color="green"
        height="100%"
        class="slide2 no-radius"
      >
        <Slide2 />
      </v-sheet>
    </v-carousel-item>
    <v-carousel-item>
      <v-sheet
        color="navy"
        height="100%"
        class="slide3 no-radius"
      >
        <Slide3 />
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import Slide1 from '../slides/Slide1'
import Slide2 from '../slides/Slide2'
import Slide3 from '../slides/Slide3'

export default {
  name: 'HeaderCarousel',
  components: {
    Slide1,
    Slide2,
    Slide3
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.no-radius {
  border-radius: 0px !important;
}
.slide1 {
  background-color: #0cbaba;
  background-image: linear-gradient(315deg, #0cbaba 0%, #380036 74%);
}
.slide2 {
  background-color: #f7b42c;
  background-image: linear-gradient(315deg, #f7b42c 0%, #fc575e 74%);
}
.slide3 {
  background-color: #7f5a83;
  background-image: linear-gradient(315deg, #7f5a83 0%, #0d324d 74%);
}
</style>
